import { z } from 'zod';
import { lineSchema } from './lineSchema';

export const reactionModifierSchema = z.object({
  id: z.number(),
  line: lineSchema,
  stoichiometry: z.number().nullable(),
  element: z.number(),
  sboTerm: z.string(),
});
